import React from 'react';
import PropTypes from 'prop-types';
import { menuToggler } from '@bd/bdcore-utilities';

function ToggleElement({ activateMenu, className, button, children, isActiveMenu }) {
  return (
    <div className={className}>
      <span role="button" tabIndex="0" onClick={activateMenu('menu')}>{button}</span>
      {isActiveMenu('menu') && children}
    </div>
  );
}

ToggleElement.propTypes = {
  button: PropTypes.node.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
};

ToggleElement.defaultProps = {
  className: undefined,
};

export default menuToggler(ToggleElement);



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ToggleElement.js